import { Util } from '@/modules/util'
import { Request } from '@/classes/Request.ts'
import { parse } from 'date-fns'

export interface IncidentIqFee {
  // Incident IQ ids are GUIDs, not integers — unlike Destiny's numeric feeId.
  feeId: string
  transactionNumber: string | null
  // The IIQ fee-definition id. Shared by every assignment of the same fee, so it
  // is what the menu item (and its finance code) is keyed on at payment time.
  sku: string | null
  description: string
  date: Date | null
  datetime: string | null
  amountDue: number
  amountTotal: number
  isFine: boolean
  allowPartial: boolean
  feeCategory: string
  type: string
  // Null until the district's menu item for this fee exists — it is created by
  // the first payment — and null again unless a form has been attached to it.
  menuItemId: number | null
  formData: string | null
  // Set once this particular charge has been paid with a form submitted.
  formSubmissionId: string | null
}

export const incidentIqFees = async (studentAccountId: TStudentAccountId) => {
  const response = await new Request().get(
    '/ajax/student/' + studentAccountId + '/incident_iq_fees'
  )
  return Util.Obj.keysToCamel(response.data.incident_iq_fees).map((fee: any) => ({
    ...fee,
    // A fee with no due date comes back null; parse() would turn that into an
    // Invalid Date, so leave it null and let the table render a blank.
    date: fee.date ? parse(fee.date, 'yyyy-MM-dd', new Date()) : null
  })) as IncidentIqFee[]
}
